import { render, staticRenderFns } from "./VBreadcrumbs.vue?vue&type=template&id=17136264&"
import script from "./VBreadcrumbs.vue?vue&type=script&lang=js&"
export * from "./VBreadcrumbs.vue?vue&type=script&lang=js&"
import style0 from "./VBreadcrumbs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports